export default __webpack_public_path__ + "files/media/marker.3b24af17.svg";